<template>
  <div id="newsCenter">
    <div class="box container" style="overflow:hidden">
      <div style="padding:20px">
        <el-row :gutter="20">
          <el-col :span="17">
            <div
              style="font-size:18px;color:#333;padding-top:20px;margin-bottom:10px;"
              class="container"
            >热点推荐</div>
            <div style="background-color:#fff;padding:20px">
              <div v-for="(item,index) of list" :key="index" class="item">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <div style="overflow:hidden;max-height:120px;">
                      <img :src="serve+item.cover" style="width:100%;">
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <router-link :to="'/viewHotNews/'+item.id">
                      <div style="font-size:16px;color:#333333">{{item.title}}</div>
                    </router-link>
                    <router-link :to="'/viewHotNews/'+item.id">
                      <div style="color:#999;margin:10px 0;line-height:1.5em">{{item.abstract}}</div>
                    </router-link>
                    <div style="color:#999999">
                      <span style="margin-right:5px">
                        <i class="far fa-eye"></i>
                      </span>
                      {{item.view}}人浏览
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="loading">
              <div
                style="font-size:16px;text-align:center;padding:20px 0;background-color:#fff;border-bottom:1px solid #ddd;"
              >加载更多</div>
            </div>
          </el-col>
          <el-col :span="7">
            <div
              style="font-size:18px;color:#333;padding-top:20px;margin-bottom:10px;"
              class="container"
            >热点推荐</div>
            <div style="background-color:#fff;padding:10px">
              <div
                v-for="(item,index) of tops"
                :key="index"
                style="border-bottom:1px solid #ddd;padding-bottom:10px;margin-bottom:10px;"
              >
                <el-row :gutter="10">
                  <el-col :span="8">
                    <div>
                      <router-link :to="'/viewHotNews/'+item.id">
                        <img :src="serve+item.cover" style="width:100%;">
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div>
                      <router-link :to="'/viewHotNews/'+item.id">
                        <div style="height:45px;overflow:hidden">{{item.title}}</div>
                      </router-link>
                      <div style="color:#999">
                        <span style="margin-right:5px">
                          <i class="far fa-eye"></i>
                        </span>
                        {{item.view}}
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      count: 1,
      list: null,
      more: true,
      loading: false,
      tops: null
    };
  },
  created() {
    //
    this.initData();
    var that = this;
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      var h1 = scrollHeight - 600;
      var h2 = scrollTop + windowHeight;
      if (scrollHeight - scrollTop - windowHeight < 600) {
        that.appendData();
      }
    };
  },
  methods: {
    appendData() {
      if (this.list && this.more && !this.loading) {
        this.count++;
        this.loading = true;
        setTimeout(() => {
          this.axios
            .get(this.serve + "/news_list", {
              params: {
                page: this.count
              }
            })
            .then(res => {
              this.loading = false;
              if (res.data.data) {
                var newarr = _.concat(this.list, res.data.data.results);
                this.list = newarr;
              } else {
                this.more = false;
              }
            });
        }, 500);
      }
    },
    initData() {
      this.axios
        .get(this.serve + "/news_list", {
          params: {
            page: this.count
          }
        })
        .then(res => {
        console.log(res)

          this.list = res.data.data.results;
        });

      this.axios.get(this.serve + "/one_week_news").then(res => {
        this.tops = res.data.data;
      });
    }
  }
};
</script>
<style lang="scss">
#newsCenter {
  a:hover {
    color: #e2211c;
  }
  .item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 20px;
    margin-bottom: 15px;
  }
}
</style>